import { Component, input } from '@angular/core';
import { SimulatorResult } from '../../models/simulator-models';

@Component({
  selector: 'app-simulator-result-summary',
  templateUrl: './simulator-result-summary.component.html',
  styleUrl: './simulator-result-summary.component.scss',
})
export class SimulatorResultSummaryComponent {
  result = input<SimulatorResult | undefined>(undefined);
}
